/*
  Aimer: vídeos do carrossel da página de produto (deferred-media.aimer-video-auto, ver snippets/product-thumbnail.liquid).
  Só baixa o vídeo quando o slide dele aparece; toca mudo e em loop enquanto está na tela e pausa quando sai
  (troca de slide no celular, troca de miniatura no desktop — slides inativos ficam display:none — ou rolagem da página).
*/
(function () {
  if (!('IntersectionObserver' in window)) return;

  const onScreen = new Set();

  function play(media) {
    if (!media.getAttribute('loaded') && typeof media.loadContent === 'function') media.loadContent(false);
    const video = media.querySelector('video');
    if (!video) return;
    video.muted = true;
    const playing = video.play();
    if (!playing) return;
    // controles ficam sempre visíveis (tocar som, pausar); autoplay bloqueado (pouca energia) toca no toque.
    playing.catch(() => video.setAttribute('controls', ''));
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onScreen.add(entry.target);
          if (!document.hidden) play(entry.target);
        } else {
          onScreen.delete(entry.target);
          const video = entry.target.querySelector('video');
          if (video) video.pause();
        }
      });
    },
    { threshold: 0.4 }
  );

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) onScreen.forEach(play);
  });

  function observeAll() {
    document.querySelectorAll('deferred-media.aimer-video-auto').forEach((media) => observer.observe(media));
  }

  observeAll();
  // troca de variante pode recriar os slides da galeria
  const galleries = new MutationObserver(observeAll);
  document.querySelectorAll('media-gallery').forEach((gallery) => galleries.observe(gallery, { childList: true, subtree: true }));
})();
